import { resolved } from 'store/createAction';
import {
  CREATE_USER,
  DELETE_USER,
  UPDATE_USER,
  GET_USERS,
  LOAD_ACCOUNT,
  LOAD_ACCOUNT_USAGE,
  LOAD_UPCOMING_INVOICE,
  UPDATE_ACCOUNT,
  LOAD_INTEGRATIONS,
  SAVE_INTEGRATION,
  TOGGLE_BANNER,
  START_SYNC,
  GET_CONNECTIONS,
  UPDATE_CONNECTION,
  LOAD_FEATURES,
  LOAD_BRANDS,
} from './types';

import * as accountSvc from 'services/account.service';
import * as usersSvc from 'services/users';

export const getUsers = (query) => ({
  type: GET_USERS,
  payload: {
    promise: usersSvc.getUsers(query),
  },
});

export const createUser = (data) => ({
  type: CREATE_USER,
  payload: {
    promise: usersSvc.createUser(data),
  },
});

export const updateUser = (data) => ({
  type: UPDATE_USER,
  payload: {
    promise: usersSvc.updateUser(data),
  },
});

export const deleteUser = (id) => ({
  type: DELETE_USER,
  payload: {
    promise: usersSvc.deleteUser(id),
  },
});

export const loadAccount = (accountId) => ({
  type: LOAD_ACCOUNT,
  payload: {
    accountId,
    promise: accountSvc.getAccount(accountId),
  },
});

export const restoreAccount = (account) => ({
  type: resolved(LOAD_ACCOUNT),
  payload: account,
});

export const loadUsage = (accountId) => ({
  type: LOAD_ACCOUNT_USAGE,
  payload: {
    promise: accountSvc.getAccountUsage(accountId),
  },
});

export const loadUpcomingInvoice = (customerId) => ({
  type: LOAD_UPCOMING_INVOICE,
  payload: {
    promise: accountSvc.loadUpcomingInvoice(customerId).then((inv) => inv[0]),
  },
});

export const updateAccount = (id, update) => ({
  type: UPDATE_ACCOUNT,
  payload: {
    promise: accountSvc.updateAccount({
      account_id: id,
      ...update,
    }),
  },
});

export const loadIntegrations = () => ({
  type: LOAD_INTEGRATIONS,
  payload: {
    promise: accountSvc.getIntegrations(),
  },
});

export const saveIntegration = (data) => ({
  type: SAVE_INTEGRATION,
  payload: {
    promise: accountSvc.saveIntegration(data),
  },
});

export const toggleSyncBanner = (show) => ({
  type: TOGGLE_BANNER,
  payload: show,
});

export const startSync = (integration) => ({
  type: START_SYNC,
  payload: integration,
});

export const getConnections = (params) => ({
  type: GET_CONNECTIONS,
  payload: {
    promise: accountSvc.getConnections(params),
  },
});

export const updateConnection = (values) => ({
  type: UPDATE_CONNECTION,
  payload: {
    promise: accountSvc.updateConnection(values),
  },
});

export const loadFeatures = () => ({
  type: LOAD_FEATURES,
  payload: {
    promise: accountSvc.getAccountFeatures(),
  },
});

export const loadBrands = (accountId) => ({
  type: LOAD_BRANDS,
  payload: {
    promise: accountSvc.getAccountProductBrands(accountId),
  },
});
